import useAppContext from "../../../../hooks/useAppContext";
import { AppContextType } from "../../../../context/AppContext";
import Address from "../../../commonComponents/Address";
import { AddressType } from "../../../../static/types/commonTypes/addressType";

const AddressPlaceOppositions:React.FC = () => {

    const {
        typeOppositionData,
        setTypeOppositionData,

        locationOppositionsRegistry,
        setLocationOppositionsRegistry,
        locationOppositionsRegistryValidity,
        setLocationOppositionsRegistryValidity,
        locationOppositionsRegistryChecked,
        setLocationOppositionsRegistryChecked,

        validityOppositionLocation,
        setValidityOppositionLocation,
        validityOppositionLocationValidity,
        setValidityOppositionLocationValidity,
        validityOppositionLocationChecked,
        setValidityOppositionLocationChecked,

    } = useAppContext() as AppContextType 

    const updateAddressOppositionRegistry = (address: Partial<AddressType>) => { setLocationOppositionsRegistry({...locationOppositionsRegistry, ...address})}
    const updateValidityOppositionLocation = (address: Partial<AddressType>) => { setValidityOppositionLocation({...validityOppositionLocation, ...address})}

    return (
        <>
            <span>
                Le lieu des oppositions doit être situé dans le même ressort de greffe que l'adresse du fonds. Si ce n'est pas le cas, indiquer le lieu des oppositions pour la correspondance et le lieu des oppositions pour la validité qui sera l'adresse du fonds.
            </span>
            <div className="container p-4">
                <div className="row mb-2 align-items-center">
                    <label htmlFor="adresse" className="col-sm-2 col-form-label">
                        Lieu <strong className="text-danger">*</strong>
                    </label>
                    <div className="col-sm-10">
                        <select
                            className="form-select w-50"
                            id="addressPlaceOppositionsData"
                            onChange={(e) => setTypeOppositionData(Number(e.target.value))}
                            value={typeOppositionData}
                        >
                            <option value={0}>Greffe identique au fonds</option>
                            <option value={1}>Autre Greffe</option>
                        </select>
                    </div>
                </div>

                    <div className="row mt-3">

                            <h6 className="mb-2 fw-bold">Lieu des oppositions pour la correspondance</h6>
                            <Address
                                address={locationOppositionsRegistry}
                                draftFieldName = 'locationOppositionsRegistry'
                                changeAddress={updateAddressOppositionRegistry}
                                checked={locationOppositionsRegistryChecked}
                                onValidationChange={(isValid: boolean) =>
                                    setLocationOppositionsRegistryValidity(isValid)
                                }
                            />
                        
                        {
                            typeOppositionData === 1 && 
                            <>
                                <h6 className="mb-2 fw-bold">Lieu des oppositions pour la validité</h6>
                                <Address
                                    address={validityOppositionLocation}
                                    draftFieldName = 'validityOppositionLocation'
                                    changeAddress={updateValidityOppositionLocation}
                                    checked={validityOppositionLocationChecked}
                                    onValidationChange={(isValid: boolean) =>
                                        setValidityOppositionLocationValidity(isValid)
                                    }
                                />
                            </>
                        }
                    </div>
            </div>
        </>

    )
}

export default AddressPlaceOppositions;